"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const overdue_1 = __importDefault(require("../../api/overdue"));
const DetailTitle_vue_1 = __importDefault(require("../DetailTitle.vue"));
const dict_1 = require("../../select/dict");
const configList = [
    {
        name: '自然人担保',
        api: overdue_1.default.overdueNaturalPersonGuarantee,
        width: 880,
        columns: [
            {
                dataIndex: 'assureMethod',
                title: '担保类型',
                align: 'center',
                customRender({ text }) {
                    return dict_1.dict.GuaranteeType.getItem(text).label;
                }
            },
            {
                dataIndex: 'fullname',
                title: '姓名',
                align: 'center'
            },
            {
                dataIndex: 'sex',
                title: '性别',
                align: 'center',
                customRender({ text }) {
                    return dict_1.dict.sex.getItem(text).label;
                }
            },
            {
                dataIndex: 'age',
                title: '年龄',
                align: 'center'
            },
            {
                dataIndex: 'mobile',
                title: '手机号',
                align: 'center'
            },
            {
                dataIndex: 'certtype',
                title: '证件类型',
                align: 'center',
                customRender({ text }) {
                    return dict_1.dict.CertType.getItem(text).label;
                }
            },
            {
                dataIndex: 'certid',
                title: '证件号',
                align: 'center'
            },
            {
                dataIndex: 'marriage',
                title: '婚姻状态',
                align: 'center',
                customRender({ text }) {
                    return dict_1.dict.marry.getItem(text).label;
                }
            },
        ]
    },
    {
        name: '法人担保',
        api: overdue_1.default.overdueCorporateGuarantee,
        width: 880,
        columns: [
            {
                dataIndex: 'customername',
                title: '担保人名称',
                align: 'center',
            },
            {
                dataIndex: 'assureMethod',
                title: '担保类型',
                align: 'center',
                customRender({ text }) {
                    return dict_1.dict.GuaranteeType.getItem(text).label;
                },
            },
            {
                dataIndex: 'assureRelation',
                title: '关系',
                align: 'center',
                customRender({ text }) {
                    return dict_1.dict.relation_type.getItem(text).label;
                },
            },
            {
                dataIndex: 'starttime',
                title: '开始时间',
                align: 'center',
            },
            {
                dataIndex: 'endtime',
                title: '结束时间',
                align: 'center',
            },
            {
                dataIndex: 'guaranteeDate',
                title: '担保期限',
                align: 'center',
            },
            {
                dataIndex: 'cgmnote',
                title: '备注',
                align: 'center',
            },
        ]
    },
    {
        name: '挂靠',
        api: overdue_1.default.overdueAffiliationGuarantee,
        width: 2000,
        columns: [
            {
                dataIndex: 'affiliatedName',
                title: '挂靠名称',
                align: 'center'
            },
            {
                dataIndex: 'certtype',
                title: '证件类型',
                align: 'center',
                customRender({ text }) {
                    return dict_1.dict.CertType.getItem(text).label;
                }
            },
            {
                dataIndex: 'certid',
                title: '证件号',
                align: 'center',
            },
            {
                dataIndex: 'legalperson',
                title: '法定代表人',
                align: 'center',
            },
            {
                dataIndex: 'mobile',
                title: '手机号',
                align: 'center',
            },
            {
                dataIndex: 'account',
                title: '银行账户',
                align: 'center',
            },
            {
                dataIndex: 'bankname',
                title: '开户银行',
                align: 'center',
            },
            {
                dataIndex: 'accnumber',
                title: '开户账号',
                align: 'center',
            },
            {
                dataIndex: 'officeprovince',
                title: '办公省份',
                align: 'center',
            },
            {
                dataIndex: 'officecity',
                title: '办公城市',
                align: 'center',
            },
            {
                dataIndex: 'bankprovince',
                title: '开户行省份',
                align: 'center',
            },
            {
                dataIndex: 'bankcity',
                title: '开户行城市',
                align: 'center',
            },
            {
                dataIndex: 'unionnumber',
                title: '联行号',
                align: 'center',
            },
        ]
    },
];
exports.default = (0, vue_1.defineComponent)({
    name: 'GuaranteeList',
    components: {
        DetailTitle: DetailTitle_vue_1.default
    },
    props: {
        id: {
            type: String,
            required: true
        },
        defaultCollapse: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            collapse: this.defaultCollapse,
            operate: false,
            index: 0,
            configList: configList,
            data: []
        };
    },
    computed: {
        currentConfig() {
            return this.configList[this.index];
        }
    },
    watch: {
        id: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.getData();
                }
            }
        }
    },
    methods: {
        getData() {
            this.data = [];
            this.operate = true;
            this.currentConfig.api.require({
                projectId: this.id
            }).then(res => {
                this.data = res.data.data;
            }).finally(() => {
                this.operate = false;
            });
        },
        onCollapseChange(value) {
            this.collapse = value;
        }
    }
});
